import axios from "axios";
import { BaseClient } from "../../../services";
import { AtualizarDadosLojistaDto, AtualizarNotificacaoLojistaDTO, AtualizarSenhaDto, FipeResponse, ProposalCombo } from "../dto/ShopkeeperDTO";

export const fetchAnuncioDetails = async (id: number) => {
    try {
        const response = await BaseClient.get(`/Anuncios/V2/Get/Anuncio/Detalhe?id_anuncio=${id}`);
        return response.data;
    } catch (error: any) {
        return error.response.data ?? {success:false, message: 'Erro ao conectar com o servidor' };
    }
};


export const fetchAnuncioDetailsAnonymous = async (id: number) => {
    try {
        const response = await BaseClient.get(`/Anuncios/V2/Get/Anuncio/Detalhe/Anonymous?id_anuncio=${id}`);
        return response.data;
    } catch (error: any) {
        return error.response.data ?? {success:false, message: 'Erro ao conectar com o servidor' };
    }
};




export const fetchQtdClick = async (id:number) => {
    try {
        const response = await BaseClient.get<number>(`/Anuncios/Get/Combo/QtdClick/${id}`);
        return response.data;
    } catch (error: any) {
        return error.response.data ?? {success:false, message: 'Erro ao conectar com o servidor' };
    }   
};

export const submitOfferAnuncio = async (data: ProposalCombo) => {
    try {
        const response = await BaseClient.post(`/Anuncios/Post/CompraOuProposta`, data);
        return response.data;
    } catch (error: any) {
        return error.response.data ?? {success:false, message: 'Erro ao conectar com o servidor' };
    }
 };

 export const fetchDashBoardShopkeeper = async ()=> {
    try {
        const response = await BaseClient.get("/Anuncios/Get/Dashboard-Revenda");
        return response.data;
    } catch (error: any) {
        return error.response.data ?? {success:false, message: 'Erro ao conectar com o servidor' };
    }
 };
 export const fetchDashBoardConcessionaria = async ()=> {
    try {
        const response = await BaseClient.get("/Anuncios/Get/Concessionarias/Disponiveis");
        return response.data;
    } catch (error: any) {
        return error.response.data ?? {success:false, message: 'Erro ao conectar com o servidor' };
    }
 };

 export const fetchFiltros = async ()=> {
    try {
        const response = await BaseClient.get("/Anuncios/Get/Filtros/Anuncios");
        return response.data;
    } catch (error: any) {
        return error.response.data ?? {success:false, message: 'Erro ao conectar com o servidor' };
    }
 };

 export const fetchAnunciosDisponiveis = async ()=> {
    try {
        const response = await BaseClient.get("/Anuncios/Get/Anuncios/Ativos-Disponiveis");
        return response.data;
    } catch (error: any) {
        return error.response.data ?? {success:false, message: 'Erro ao conectar com o servidor' };
    }
 };

export const fetchFipe = async (
  codigoFipe: string,
  anoModelo: number
): Promise<string | null> => {
  try {
    const response = await axios.get<FipeResponse[]>(
      `https://brasilapi.com.br/api/fipe/preco/v1/${codigoFipe}`
    );

    const veiculo = response.data.find(
      (v) => v.anoModelo === anoModelo
    );

    return veiculo?.valor ?? null;
  } catch (error: any) {
    console.error(error);
    return null;
  }
};

export const fetchMinhasComprasDashBoard = async () => {
    try {
        const response = await BaseClient.get("/Anuncios/Get/Dashboard-Revenda-Estatisticas");
        return response.data;
    } catch (error: any) {
        return error.response.data ?? {success:false, message: 'Erro ao conectar com o servidor' };
    }
};
export const fetchMinhasCompras = async () => {
    try {
        const response = await BaseClient.get("/Anuncios/Get/Propostas-Revenda");
        return response.data;
    } catch (error: any) {
        return error.response.data ?? {success:false, message: 'Erro ao conectar com o servidor' };
    }
};

export const fetchQrCodeAnuncio = async (id_anuncio: number) => {
    try {
        const response = await BaseClient.get(`Anuncios/Get/QrCode/Anuncio/${id_anuncio}`);
        return response.data;
    } catch (error: any) {
        return error.response.data ?? {success:false, message: 'Erro ao conectar com o servidor' };
    }
};

export const fetchDadosLojista = async () => {
    try {
        const response = await BaseClient.get(`Anuncios/Get/Lojista/Dados`);
        return response.data;
    } catch (error: any) {
        return error.response.data ?? {success:false, message: 'Erro ao conectar com o servidor' };
    }
};
export const atualizarDadosLojista = async (dto: AtualizarDadosLojistaDto) => {
    try {
        const response = await BaseClient.put(`Anuncios/Update/Lojista/Dados`, dto );
        return response.data;
    } catch (error: any) {
        return error.response.data ?? {success:false, message: 'Erro ao conectar com o servidor' };
    }
};

export const atualizarSenha = async (dto: AtualizarSenhaDto) => {
    try {
        const response = await BaseClient.put('Anuncios/Update/Usuario/Senha', dto );
        return response.data;
    } catch (error: any) {
        return error.response.data ?? {success:false, message: 'Erro ao conectar com o servidor' };
    }
};


export const atualizarNotificacaoLojista = async (dto: AtualizarNotificacaoLojistaDTO) => {
    try {
        const response = await BaseClient.put('Anuncios/Update/Notificacao/Lojista', dto );
        return response.data;
    } catch (error: any) {
        return error.response.data ?? {success:false, message: 'Erro ao conectar com o servidor' };
    }
};

export const apagarContaLojista = async () => {
    try {
        const response = await BaseClient.put('Anuncios/Desativar/Lojista/Excluir');
        return response.data;
    } catch (error: any) {
        return error.response.data ?? {success:false, message: 'Erro ao conectar com o servidor' };
    }
};